import axios from "axios";
import { Constants, CookieService, Utils } from "../../../shared";

export const ObjectsHierarchyService = {
 
  /**
   * Deletes a hierarchy by its ID.
   * @param {number} id - The ID of the hierarchy to delete.
   * @returns {Promise<*>} - A promise that resolves to the response object from the 
   * DELETE request or rejects if the request fails.
   * @throws {Error} - If the ID is not provided or is not a number.
   */
  deleteHierarchy: (id) => {
    return axios.delete(Constants.AllHierarchyUrl,
      {
        headers: {
          ansid: CookieService.getCookie("ANsid"),
          clientid: Utils.getRouteParam("clientid")
        },
        params: {id: id}
      }
      ).then((response) => {
          return response;
      })
  },

  /**
   * Updates a hierarchy by its ID.
   * @param {number} id - The ID of the hierarchy to update.
   * @param {Object} payload - The data to update the hierarchy with.
   * @returns {Promise<*>} - A promise that resolves to the response object from the
   * PUT request or rejects if the request fails.
   * @throws {Error} - If the ID is not provided or is not a number.
  */
  updateHierarchyTemplate: (payload) => {
    return axios.put(Constants.AllHierarchyUrl,
      payload,
      {
        headers: {
          ansid: CookieService.getCookie("ANsid"),
          clientid: Utils.getRouteParam("clientid")
        }
      },
    ).then((response) => {
      return response;
    })
  },

  /**
   * Adds a new hierarchy.
   * @param {Object} payload - The data to create the hierarchy with.
   * @returns {Promise<*>} - A promise that resolves to the response object from the
   * POST request or rejects if the request fails.
   * @throws {Error} - If the payload is not provided or is not an object.
   */
  addHierarchyTemplate: (payload) => {
    return axios.post(Constants.AllHierarchyUrl,
      payload,
      {
        headers: {
          ansid: CookieService.getCookie("ANsid"),
          clientid: Utils.getRouteParam("clientid")
        }
      },
    ).then((response) => {
      return response;
    })
  },

  /**
   * Gets the hierarchy column options.
   * @returns {Promise<*>} - A promise that resolves to the response object from the
   * GET request or rejects if the request fails.
   */
  getHierarchyColumnOptions: () => {
    return axios.get(Constants.hierarchyColumnOptionsUrl,
      {
        params: {clientId: Utils.getRouteParam("clientid")},
        headers: {
          ansid: CookieService.getCookie('ANsid'),
          clientid: Utils.getRouteParam("clientid")
        }
      })
  },
  
  /**
   * Gets all hierarchy data.
   * @returns {Promise<*>} - A promise that resolves to the response object from the
   * GET request or rejects if the request fails.
   */
  getAllHierarchyData: () => {
    return axios.get(Constants.AllHierarchyUrl,
    {
      params: {clientId: Utils.getRouteParam("clientid"), include_default: true},
      headers: {
        ansid: CookieService.getCookie("ANsid"),
        clientid: Utils.getRouteParam("clientid")
      }
    }
    ).then((response) => {
      return response;
    })
  },
};